module.exports = __webpack_public_path__ + "img/meteor.13eaff1b.svg";